module.exports = __webpack_public_path__ + "images/workspaces-preamble/workspaces-preamble-prompt-board-image.8de609db7af65df4bde9.png";